"use strict";
// Copyright © Veeam Software Group GmbH.
Object.defineProperty(exports, "__esModule", { value: true });
exports.themeCopier = void 0;
const OldTokens_1 = require("../tokens/global/OldTokens");
const themeCopier = (oldTheme, newTheme) => {
    Object.keys(OldTokens_1.oldTokens).forEach((tokenName) => {
        const token = OldTokens_1.oldTokens[tokenName];
        newTheme.designTokens.set(token, `${oldTheme[tokenName].value}`);
    });
};
exports.themeCopier = themeCopier;
//# sourceMappingURL=themeCopier.js.map